import {
  Box,
  Container,
  Link,
  Grid,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
  TextField,
  MenuItem,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../Analysis/Assets/Logo/logo2.svg";
import { colleges } from "../data/data";
import {
  useUserOtpVerifyMutation,
  useUserRegiserMutation,
} from "../../app/services/quizCore";
import "../../Analysis/components/ToggleSidebar.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCookies } from "react-cookie";

const RegisterMobile = () => {
  const navigate = useNavigate();
  const graduationYears = [
    2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029,
  ];
  const [cookies, setCookie] = useCookies(["o1JraEmail"]);
  const [isChecked, setIsChecked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [otherCollege, setOtherCollege] = useState(true);

  const [displayOtpInput, setDisplayOtpInput] = useState(false);
  const [otp, setOtp] = useState("");

  const [userData, setUserData] = useState({
    name: "",
    email: "",
    college: "",
    phone: "",
    graduationYear: "",
  });

  const [validations, setValidations] = useState({
    name: [true, ""],
    email: [true, ""],
    college: [true, ""],
    phone: [true, ""],
    graduationYear: [true, ""],
  });

  const handleCheckboxChange = (event) => {
    if (otp.length === 0 && isChecked === false) {
      toast.error("Enter OTP", {
        toastId: "Otp not entered",
      });
      return;
    }
    setIsChecked(event.target.checked);
  };

  const validateData = () => {
    var curr_validation = {
      name: [true, ""],
      email: [true, ""],
      college: [true, ""],
      graduationYear: [true, ""],
      phone: [true, ""],
    };
    var all_valid = true;

    if (userData.name.length === 0) {
      curr_validation["name"][0] = false;
      curr_validation["name"][1] = "Name can not be empty";
      all_valid = false;
    }

    const valid_email = new RegExp("^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$");
    if (!valid_email.test(userData.email)) {
      curr_validation["email"][0] = false;
      curr_validation["email"][1] = "Invalid email";
      all_valid = false;
    }

    if (userData.college.length === 0) {
      curr_validation["college"][0] = false;
      curr_validation["college"][1] = "College name can not be empty";
      all_valid = false;
    }

    if (userData.graduationYear.length === 0) {
      curr_validation["graduationYear"][0] = false;
      curr_validation["graduationYear"][1] = "Graduation year can not be empty";
      all_valid = false;
    }

    const valid_phone = new RegExp("^[1-9][0-9]{9}$");
    if (!valid_phone.test(userData.phone)) {
      curr_validation["phone"][0] = false;
      curr_validation["phone"][1] =
        "Enter only 10 digit phone number (without 0 or country code)";
      all_valid = false;
    }

    setValidations(curr_validation);
    return all_valid;
  };

  const [
    jraRegisterUserApiCall,
    { data: responseData, isLoading, isError, isSuccess, error },
  ] = useUserRegiserMutation();

  const handleInputs = (e) => {
    var key = e.target.name;
    var value = e.target.value;
    setUserData({ ...userData, [key]: value });
  };

  const handleRegisterUser = () => {
    const all_valid = validateData();
    if (!all_valid) return;
    jraRegisterUserApiCall(userData);
  };

  useEffect(() => {
    if (isSuccess) {
      toast.success("User Registered Successfully. Check your mail for OTP!", {
        toastId: "registerSuccess",
      });
      // handleStartQuiz();
      setDisplayOtpInput(true);
    } else if (isError) {
      toast.error(error.data.message, {
        toastId: "registerError",
      });
    }
  }, [isSuccess, isError]);

  const handleStartQuiz = () => {
    setLoader(true);
    setCookie("o1JraEmail", userData.email, { maxAge: 15 * 60 * 1000 });
    setTimeout(() => {
      navigate("/quiz");
    }, 4000);
  };

  const [
    jraVerifyOtpApiCall,
    {
      data: verifyResponseData,
      isLoading: isVerifyLoading,
      isError: isVerifyError,
      isSuccess: isVerifySuccess,
      error: verifyError,
    },
  ] = useUserOtpVerifyMutation();

  const handleEmailVerification = () => {
    jraVerifyOtpApiCall({
      email: userData.email,
      token: otp,
    });
  };

  useEffect(() => {
    if (isVerifySuccess) {
      toast.success("User Verified Successfully. Redirecting to Quiz", {
        toastId: "verifySuccess",
      });
      setLoader(true);
      setCookie("o1JraEmail", userData.email, { maxAge: 15 * 60 * 1000 });
      setTimeout(() => {
        navigate("/quiz");
      }, 4000);
    } else if (isVerifyError) {
      setOtp("");
      setIsChecked(false);
      toast.error(verifyError.data.message, {
        toastId: "verifyError",
      });
    }
  }, [isVerifySuccess, isVerifyError]);

  return (
    <div>
      <div className="container-fluid mt-3 mb-3">
        <nav className="navbar navbar-expand-lg shadow-md">
          <div className="container-fluid p-2">
            <Link className="navbar-brand text-primary mr-0" to="/" href="/">
              <img
                className="brand-logo"
                src={Logo}
                alt="O(1) Coding Club"
                srcSet=""
              />
            </Link>
            <h3
              style={{
                color: "white",
                marginLeft: "auto",
                textTransform: "capitalize",
                textAlign: "center",
                paddingRight: "2%",
              }}
            >
              JRA
            </h3>
          </div>
        </nav>
      </div>

      {/* {(loader || isLoading) && ( */}
      {(loader || isLoading || isVerifyLoading) && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1000,
          }}
          open={true}
        >
          <CircularProgress color="secondary" />
        </Backdrop>
      )}

      <Box
        style={{
          textAlign: "center",
          minHeight: "75vh",
          padding: "2%",
        }}
      >
        <Grid
          container
          style={{
            padding: "15% 5%",
            backgroundColor: "#0F143C",
            // backgroundImage:
            //   "linear-gradient(to right, #000000, #19072f, #8224f3)",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            component="form"
            noValidate
            autoComplete="off"
            style={{ padding: "1%",  width: "100%" }}
          >
            <Typography
              variant="h5"
              style={{ marginBottom: "10%", color: "#fff", fontWeight: 500 }}
            >
              Registration
            </Typography>

            <TextField
              margin={"dense"}
              InputProps={{
                readOnly: displayOtpInput,
              }}
              sx={{
                input: { color: "#fff" },
                label: { color: "#fff" },
              }}
              fullWidth
              name="name"
              type="text"
              error={!validations.name[0]}
              helperText={validations.name[1]}
              label="Enter your full name"
              onChange={handleInputs}
              value={userData.name}
              required
            />

            <TextField
              margin={"dense"}
              InputProps={{
                readOnly: displayOtpInput,
              }}
              sx={{
                input: { color: "#fff" },
                label: { color: "#fff" },
              }}
              fullWidth
              name="email"
              type="email"
              error={!validations.email[0]}
              helperText={validations.email[1]}
              label="Enter your email"
              onChange={handleInputs}
              value={userData.email}
              required
            />

            {otherCollege ? (
              <TextField
                margin={"dense"}
                style={{boxSizing: "border-box",
                  width: "100%"}}
                InputProps={{
                  style: { color: "#fff" },
                  readOnly: displayOtpInput,
                }}
                sx={{
                  input: { color: "#fff" },
                  label: { color: "#fff" },
                }}
                fullWidth
                name="college"
                select
                error={!validations.college[0]}
                helperText={validations.college[1]}
                label="Select your college"
                onChange={handleInputs}
                value={userData.college}
                required
              >
                {colleges.map((option, key) => (
                  <MenuItem
                    key={key}
                    value={option}
                    style={{ color: "#fff", backgroundColor: "#000" }}
                  >
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            ) : (
              <TextField
                margin={"dense"}
                sx={{
                  input: { color: "#fff" },
                  label: { color: "#fff" },
                }}
                fullWidth
                name="college"
                type="text"
                label="Enter your college name"
                onChange={handleInputs}
                value={userData.college}
                required
              />
            )}

            {otherCollege ? (
              <Typography
                style={{
                  textAlign: "center",
                  fontSize: "10",
                  color: "#fff",
                }}
              >
                Your college not in list?{" "}
                <Button onClick={() => setOtherCollege(!otherCollege)}>
                  Add here
                </Button>
              </Typography>
            ) : (
              <Typography
                style={{
                  textAlign: "center",
                  fontSize: "10",
                  color: "#fff",
                }}
              >
                <Button onClick={() => setOtherCollege(!otherCollege)}>
                  Choose from the list
                </Button>
              </Typography>
            )}

            <TextField
              margin={"dense"}
              InputProps={{
                style: { color: "#fff" },
                readOnly: displayOtpInput,
              }}
              sx={{
                input: { color: "#fff" },
                label: { color: "#fff" },
              }}
              fullWidth
              name="graduationYear"
              select
              error={!validations.graduationYear[0]}
              helperText={validations.graduationYear[1]}
              label="Graduation Year"
              onChange={handleInputs}
              value={userData.graduationYear}
              required
            >
              {graduationYears.map((option, key) => (
                <MenuItem
                  key={key}
                  value={option}
                  style={{ color: "#fff", backgroundColor: "#000" }}
                >
                  {option}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              margin={"dense"}
              InputProps={{
                readOnly: displayOtpInput,
              }}
              sx={{
                input: { color: "#fff" },
                label: { color: "#fff" },
              }}
              fullWidth
              name="phone"
              type="number"
              error={!validations.phone[0]}
              helperText={validations.phone[1]}
              label="Enter your WhatsApp no."
              onChange={handleInputs}
              value={userData.phone}
              required
            />

            <TextField
              margin={"dense"}
              sx={{
                input: { color: "#fff" },
                label: { color: "#fff" },
              }}
              style={{ display: displayOtpInput ? "" : "none" }}
              fullWidth
              name="otp"
              type="text"
              label="Enter OTP received on email"
              onChange={(e) => setOtp(e.target.value)}
              value={otp}
              required
            />

            <FormControlLabel
              style={{
                margin: "2% 0",
                color: "lightgreen",
                display: "flex",
                textAlign: "justify",
                display: displayOtpInput ? "" : "none",
              }}
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  style={{
                    margin: "1%",
                    color: "lightgreen",
                  }}
                />
              }
              label="I solemnly swear I will be honest in this 30 second quiz, so that
              my placement report & roadmaps are as accurate as possible!"
            />
          </Box>

          <Grid
            container
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "5%",
            }}
          >
            <Button
              variant="contained"
              style={{
                backgroundColor: "darkgreen",
                fontSize: "18px",
              }}
              // onClick={handleRegisterUser}
              // disabled={!isChecked}
              onClick={
                displayOtpInput ? handleEmailVerification : handleRegisterUser
              }
              disabled={displayOtpInput && !isChecked}
            >
              {/* {"Start Quiz"} */}
              {displayOtpInput ? "Start Quiz" : "Register"}
            </Button>
          </Grid>
        </Grid>
      </Box>

      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        theme="colored"
      />
    </div>
  );
};

export default RegisterMobile;
